import { render, staticRenderFns } from "./PosSaleCard.vue?vue&type=template&id=ec3fadba&scoped=true&"
import script from "./PosSaleCard.vue?vue&type=script&lang=js&"
export * from "./PosSaleCard.vue?vue&type=script&lang=js&"
import style0 from "./PosSaleCard.vue?vue&type=style&index=0&id=ec3fadba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec3fadba",
  null
  
)

export default component.exports